import api from './api'

export interface ChatFolder {
    id: number
    name: string
    color: string
    sort_order: number
    leads_count: number
    created_at: string
}

export interface ChatFolderPayload {
    name: string
    color?: string
    sort_order?: number
}

// Папки чатов приватны: сервер всегда фильтрует их по текущему оператору,
// поэтому клиенту не нужно передавать чей-либо идентификатор.
export const chatFoldersApi = {
    getSettings: () => api.get<{ enabled: boolean }>('/chat-folders/settings'),

    updateSettings: (enabled: boolean) => api.put<{ enabled: boolean }>('/chat-folders/settings', { enabled }),

    getFolders: () => api.get<ChatFolder[]>('/chat-folders'),

    getAssignments: () => api.get<{ assignments: Record<string, number> }>('/chat-folders/assignments'),

    createFolder: (data: ChatFolderPayload) => api.post<ChatFolder>('/chat-folders', data),

    updateFolder: (folderId: number, data: ChatFolderPayload) =>
        api.put<ChatFolder>(`/chat-folders/${folderId}`, data),

    deleteFolder: (folderId: number) => api.delete(`/chat-folders/${folderId}`),

    assignLead: (leadId: number, folderId: number | null) =>
        api.post('/chat-folders/assign', { lead_id: leadId, folder_id: folderId }),
}
